import React from "react";
import { RecoveryMethods } from "./RecoveryMethods";
import { ActiveSessions } from "./ActiveSessions";
import { TwoFactorAuth } from "./TwoFactorAuth";
import { t, Locale } from "../../i18n";

export function SecuritySettings(props: { locale: Locale }) {
  const locale = props.locale;
  return (
    <div>
      <h2 style={{ marginTop: 0, marginBottom: "4px" }}>{t(locale, "security.title")}</h2>
      <p style={{ color: "var(--muted)", marginTop: 0, marginBottom: "24px" }}>{t(locale, "security.description")}</p>

      {/* Password Card */}
      <div style={{ background: "var(--canvas)", border: "1px solid var(--line)", borderRadius: "8px", padding: "20px", marginBottom: "20px" }}>
        <h3 style={{ marginTop: 0, fontSize: "15px", fontWeight: 600, marginBottom: "16px" }}>{t(locale, "security.password.title")}</h3>
        <button
          style={{
            background: "transparent",
            border: "1px solid var(--control-border)",
            color: "var(--text)",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px"
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "var(--hover-bg)")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          {t(locale, "security.password.change")}
        </button>
        <div style={{ fontSize: "12px", color: "var(--muted)", marginTop: "8px" }}>
          {t(locale, "security.password.lastChanged")}
        </div>
      </div>

      {/* Two-Factor Authentication Card */}
      <div style={{ marginBottom: "20px" }}>
        <TwoFactorAuth locale={locale} />
      </div>

      {/* Recovery Methods Card */}
      <div style={{ background: "var(--canvas)", border: "1px solid var(--line)", borderRadius: "8px", padding: "20px", marginBottom: "20px" }}>
        <RecoveryMethods locale={locale} />
      </div>

      {/* Active Sessions Card */}
      <div style={{ background: "var(--canvas)", border: "1px solid var(--line)", borderRadius: "8px", padding: "20px", marginBottom: "20px" }}>
        <ActiveSessions locale={locale} />
      </div>

      {/* TODO: Delete Account card — pending account deletion flow */}
    </div>
  );
}
